module.exports = __webpack_public_path__ + "static/hyperv_39.ddd2c1b7.jpg";